import { Link, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';

export default function Navigation() {
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const shouldBeTransparent = isHome && !scrolled;

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${shouldBeTransparent ? 'bg-transparent' : 'bg-white shadow-md'}`}>
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3 cursor-pointer">
          <img src="https://public.readdy.ai/ai/img_res/901ed16d-d90a-4b32-8886-5c3858e19578.png" alt="Logo Iliade" className="h-12 w-12 object-contain" />
          <span className={`font-serif text-xl font-bold ${shouldBeTransparent ? 'text-white' : 'text-gray-900'}`}>L'Iliade Didattica</span>
        </Link>
        <div className="flex items-center gap-8">
          <Link to="/" className={`hover:opacity-70 transition-opacity whitespace-nowrap ${shouldBeTransparent ? 'text-white' : 'text-gray-900'}`}>Home</Link>
          <Link to="/introduzione" className={`hover:opacity-70 transition-opacity whitespace-nowrap ${shouldBeTransparent ? 'text-white' : 'text-gray-900'}`}>Introduzione</Link>
          <Link to="/contesto-storico" className={`hover:opacity-70 transition-opacity whitespace-nowrap ${shouldBeTransparent ? 'text-white' : 'text-gray-900'}`}>Contesto Storico</Link>
          <Link to="/personaggi" className={`hover:opacity-70 transition-opacity whitespace-nowrap ${shouldBeTransparent ? 'text-white' : 'text-gray-900'}`}>Personaggi</Link>
          <Link to="/timeline" className={`hover:opacity-70 transition-opacity whitespace-nowrap ${shouldBeTransparent ? 'text-white' : 'text-gray-900'}`}>Timeline</Link>
          <Link to="/risorse" className={`hover:opacity-70 transition-opacity whitespace-nowrap ${shouldBeTransparent ? 'text-white' : 'text-gray-900'}`}>Risorse</Link>
        </div>
      </div>
    </nav>
  );
}
